import { Stack, SvgIcon, Typography } from '@mui/material'
import custom from '../../../styles/mui/szVariables.json'

export default function CardTitle({ id, icon, cardTitle, hoverIcon }: any) {

    return (
        <Stack alignItems="start" direction="row" 
            justifyContent="flex-center" height="20px">
            <Stack alignItems="center" 
                    direction="row" 
                    justifyContent="center" 
                    width="100%">
                <SvgIcon viewBox='0 0 24 24' > {icon} </SvgIcon>
                <Typography sx={{ ml: custom.spacing.xxs }} 
                    variant="szHeading.Bold.xxSmall" 
                    // fontSize={{
                    //     xs: '12px', sm: '16px', 
                    //     md: '16px', lg: '16px'
                    // }}
                    noWrap={true} >
                    {cardTitle}
                </Typography>
                <SvgIcon id={id+"hoverIcon"}
                    visibility="hidden"
                    viewBox='0 0 20 20'
                    sx={{ 
                        ml: 'auto'
                    }}> 
                    {hoverIcon} 
                </SvgIcon>
            </Stack>
        </Stack>  
    )
}